import Reflux from 'reflux';

var actions = Reflux.createActions([
  'getSupplier',
  'saveSupplier',
  'getSuppliers',
  'getAvailability',
  'addAvailability',
  'removeAvailability',
  'saveAvailability',
  'getSupplierAttribute',
  'saveSupplierAttribute',
  'getDocuments',
  'deleteDocument',
  'getDemos',
  'deleteDemo',
  'updateDemo',
  'addDemo',
  'getCountries',
  'getTimezones',
]);

export { actions };
